<template>
  <div>
    <div v-if="label || subLabel" class="v-prism-code__header">
      <span class="label">{{ label }}</span>
      <span class="subLabel">{{ additionalText }}</span>
    </div>
    <pre :class="preClass">
    <code v-if="!editorActive" :key="codeValue" ref="prism" :class="codeClass" @keydown="highlight" @click="codeAreaClick">
       {{codeValue}}
    </code>
    <textarea
            v-if="editorActive"
            :value="codeValue"
            @input="_updateArea"
            ref="textarea"
            @blur="onBlur"
    ></textarea>
  </pre>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import Prism from "prismjs";

import withKeepSelection from "@/mixins/withKeepSelection";

// css
import "prismjs/themes/prism-okaidia.css";
import "prismjs/components/prism-scss.min";
import "prismjs/plugins/autolinker/prism-autolinker.min";
import "prismjs/plugins/autolinker/prism-autolinker.css";

export default Vue.component("VPrismCode", {
  props: {
    plugins: VueTypes.array,
    code: VueTypes.string.def(""),
    language: VueTypes.string.def("markup"),
    label: VueTypes.string,
    subLabel: VueTypes.string,
    additionalText: VueTypes.string,
    withSwitch: VueTypes.bool
  },

  mixins: [withKeepSelection],

  data() {
    return {
      codeValue: this.code,
      editorActive: false
    };
  },

  methods: {
    _updateArea(e) {
      const { value } = e.target;
      this.codeValue = value;
      this.$emit("change", value);
    },

    highlight() {
      const { prism: prismRef } = this.$refs;

      if (prismRef) {
        Prism.highlightElement(prismRef);
      }
    },

    codeAreaClick() {
      this.editorActive = true;
      setTimeout(() => this.$refs.textarea.focus(), 0);
    },

    onBlur() {
      this.editorActive = false;
      this.$emit("blur");
    }
  },

  computed: {
    preClass() {
      return !this.plugins ? "" : this.plugins.join(" ");
    },

    codeClass() {
      return `language-${this.language}`;
    }
  },

  mounted() {
    this.highlight();
  },

  updated() {
    this.highlight();
  },

  watch: {
    code(val) {
      this.codeValue = val;
    }
  }
});
</script>

<style lang="scss">
.v-prism-code__header {
  font-size: 15px;
  margin-bottom: 14px;
  display: grid;
  grid-auto-flow: column;
}

.label {
  font-family: Lato-Bold, Arial, sans-serif;
  color: $main-text-color;
}

.subLabel {
  display: inline-block;
  font-size: 14px;
  color: $secondary-text-color;
  font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
  margin-left: 15px;
}

pre[class*="language-"] {
  position: relative;
  padding: 0;

  border-radius: 3px;
  min-width: 570px;
  height: 353px;
  box-shadow: none;
  margin: 0;

  &,
  textarea {
    background: $secondary-text-color;
  }

  code,
  textarea {
    position: absolute;
    top: 0;
    left: 0;
    resize: none;
    border: none;
    color: $white;
    min-height: 100%;
    min-width: 100%;
    font-family: Lato-Light, Arial, sans-serif;
    font-style: italic;
    font-weight: 300;
    font-size: 15px;
    outline: none;
    text-shadow: 0 1px rgba(0, 0, 0, 0.3);
    line-height: unset;
    display: inline-block;
    white-space: pre;
  }

  textarea {
    padding: 15px 11px;
  }

  code {
    top: -5px;
    padding: 0 10px;
  }
}

/*@media screen and (min-width: 1920px) {*/
/*  pre[class*="language-"] {*/
/*    height: 500px;*/
/*  }*/
/*}*/
</style>
